import React, { useState } from 'react';
import { Space } from 'antd';
import ScreenerControl from './ScreenerControl';

const QueryBuilder = ({ metrics, onAddFilter }) => {

    const [filterValues, setFilterValues] = useState(
       metrics &&  Object.keys?.(metrics)?.reduce?.((acc, key) => {
            acc[key] = { condition: 'greater', value: 0 }; // Default condition and value
            return acc;
        }, {})
    );
    if (!metrics) {
        return null;
    }

    const handleConditionChange = (metric, newCondition) => {
        setFilterValues(prev => ({
            ...prev,
            [metric]: { ...prev[metric], condition: newCondition, value: newCondition === 'range' ? [0, 100] : 0, active: true }
        }));
        onAddFilter(metric, newCondition, [0], true); // Activate filter
    };

    const handleValueChange = (metric, newValue) => {
        setFilterValues(prev => ({
            ...prev,
            [metric]: { ...prev[metric], value: newValue, active: true }
        }));
        onAddFilter(metric, filterValues[metric].condition, newValue, true); // Update filter
    };

    const handleClearFilter = (metric) => {
        setFilterValues(prev => ({
            ...prev,
            [metric]: { condition: 'greater', value: 0, active: false }
        }));
        onAddFilter(null, null, null, false); // Clear filter by passing false
    };

    return (
        <Space direction={'vertical'} className={'hide-scrollbar'} style={{ maxHeight: '90vh', overflowY: 'auto', padding: '15px', width: '100%' }}>
            {Object.keys(metrics).map((metric) => (
                <ScreenerControl
                    key={metric}
                    metric={metric}
                    metricData={metrics[metric]}
                    filterValues={filterValues}
                    onClear={handleClearFilter}
                    onConditionChange={handleConditionChange}
                    onValueChange={handleValueChange}
                />
            ))}
        </Space>
    );
};

export default QueryBuilder;
